// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.guide-slot-dialog {
  width: 100%;
  max-width: min(640px, 100%);
  box-sizing: border-box;
  padding: 1.35rem 1.4rem 1.5rem;
  max-height: min(90vh, 860px);
  max-height: min(90dvh, 860px);
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1.1rem;
}
.dialog-header .eyebrow {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #5ea1d8;
}
.dialog-header h2 {
  margin: 0.25rem 0 0.35rem;
  font-size: 1.35rem;
  color: #0f172a;
}
.dialog-header .subtitle {
  margin: 0;
  color: #64748b;
  font-size: 0.9rem;
  line-height: 1.45;
  max-width: 480px;
}

.close-btn {
  border: none;
  background: #f1f5f9;
  border-radius: 999px;
  width: 2rem;
  height: 2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.balance-banner {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 1rem;
  margin-bottom: 1rem;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}
.balance-banner .label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
}
.balance-banner .value {
  font-weight: 700;
  color: #0f172a;
}

.pack-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
  margin-bottom: 1.25rem;
}

.pack-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25rem;
  padding: 0.9rem;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  background: #fff;
  cursor: pointer;
  text-align: left;
}
.pack-card.selected {
  border-color: #5ea1d8;
  box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.35);
}
.pack-card.featured {
  border-color: rgba(232, 62, 140, 0.35);
}
.pack-card .badge {
  position: absolute;
  top: -0.5rem;
  right: 0.65rem;
  background: #e83e8c;
  color: #fff;
  font-size: 0.65rem;
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
}
.pack-card .pack-name {
  font-weight: 700;
  color: #0f172a;
}
.pack-card .pack-guides {
  color: #5ea1d8;
  font-weight: 600;
}
.pack-card .pack-price {
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
}
.pack-card .pack-note {
  font-size: 0.75rem;
  color: #64748b;
}

.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}
.dialog-actions .btn-cancel,
.dialog-actions .btn-purchase {
  border-radius: 999px;
  padding: 0.65rem 1.1rem;
  font-weight: 600;
  cursor: pointer;
}
.dialog-actions .btn-cancel {
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #334155;
}
.dialog-actions .btn-purchase {
  border: none;
  background: #e83e8c;
  color: #fff;
}

/* Dark mode — guide slot top-up modal */
:host-context(body.theme-dark) .guide-slot-dialog {
  background: #111827 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .dialog-header .eyebrow {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .dialog-header h2 {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .dialog-header .subtitle {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .close-btn {
  background: #1f2937 !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .close-btn mat-icon,
:host-context(body.theme-dark) .close-btn .mat-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .balance-banner {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .balance-banner .label {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .balance-banner .value {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .pack-card {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.28) !important;
}
:host-context(body.theme-dark) .pack-card.selected {
  border-color: #5ea1d8 !important;
  box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.35) !important;
}
:host-context(body.theme-dark) .pack-card.featured {
  border-color: rgba(232, 62, 140, 0.45) !important;
}
:host-context(body.theme-dark) .pack-card .pack-name,
:host-context(body.theme-dark) .pack-card .pack-price {
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .pack-card .pack-guides {
  color: #93c5fd !important;
}
:host-context(body.theme-dark) .pack-card .pack-note {
  color: #94a3b8 !important;
}
:host-context(body.theme-dark) .dialog-actions .btn-cancel {
  background: #1f2937 !important;
  border-color: rgba(148, 163, 184, 0.45) !important;
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .dialog-actions .btn-purchase {
  color: #ffffff !important;
}

@media (max-width: 640px) {
  .guide-slot-dialog {
    padding: 1rem 0.9rem calc(1rem + env(safe-area-inset-bottom, 0px));
    max-height: calc(100vh - 16px);
    max-height: calc(100dvh - 16px);
    border-radius: 16px;
  }
  .dialog-header {
    gap: 0.65rem;
    margin-bottom: 0.9rem;
  }
  .dialog-header h2 {
    font-size: 1.15rem;
  }
  .dialog-header .subtitle {
    font-size: 0.82rem;
    max-width: none;
  }
  .close-btn {
    width: 32px;
    height: 32px;
  }
  .balance-banner {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.35rem;
    padding: 0.7rem 0.85rem;
  }
  .pack-grid {
    grid-template-columns: 1fr;
    gap: 0.65rem;
    margin-bottom: 1rem;
  }
  .pack-card {
    padding: 0.9rem;
  }
  .dialog-actions {
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 0.55rem;
  }
  .dialog-actions .btn-cancel,
  .dialog-actions .btn-purchase {
    width: 100%;
    min-height: 44px;
    border-radius: 8px;
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/guide-slot-purchase-dialog/guide-slot-purchase-dialog.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,WAAA;EACA,2BAAA;EACA,sBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;AAEF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,qBAAA;AAEF;AAAE;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAEJ;AACE;EACE,yBAAA;EACA,kBAAA;EACA,cAAA;AACJ;AAEE;EACE,SAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AADF;AAGE;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AADJ;AAIE;EACE,gBAAA;EACA,cAAA;AAFJ;;AAMA;EACE,aAAA;EACA,gDAAA;EACA,YAAA;EACA,sBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAHF;AAKE;EACE,qBAAA;EACA,8CAAA;AAHJ;AAME;EACE,sCAAA;AAJJ;AAOE;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EACA,oBAAA;AALJ;AAQE;EACE,gBAAA;EACA,cAAA;AANJ;AASE;EACE,cAAA;EACA,gBAAA;AAPJ;AAUE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AARJ;AAWE;EACE,kBAAA;EACA,cAAA;AATJ;;AAaA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;AAVF;AAYE;;EAEE,oBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAVJ;AAaE;EACE,yBAAA;EACA,gBAAA;EACA,cAAA;AAXJ;AAcE;EACE,YAAA;EACA,mBAAA;EACA,WAAA;AAZJ;;AAgBA,wCAAA;AAEE;EACE,8BAAA;EACA,yBAAA;AAdJ;AAkBI;EACE,yBAAA;AAhBN;AAmBI;EACE,yBAAA;AAjBN;AAoBI;EACE,yBAAA;AAlBN;AAsBE;EACE,8BAAA;EACA,yBAAA;AApBJ;AAsBI;;EAEE,yBAAA;AApBN;AAwBE;EACE,8BAAA;EACA,kDAAA;AAtBJ;AAwBI;EACE,yBAAA;AAtBN;AAyBI;EACE,yBAAA;AAvBN;AA2BE;EACE,8BAAA;EACA,kDAAA;AAzBJ;AA2BI;EACE,gCAAA;EACA,yDAAA;AAzBN;AA4BI;EACE,iDAAA;AA1BN;AA6BI;;EAEE,yBAAA;AA3BN;AA8BI;EACE,yBAAA;AA5BN;AA+BI;EACE,yBAAA;AA7BN;AAkCI;EACE,8BAAA;EACA,kDAAA;EACA,yBAAA;AAhCN;AAmCI;EACE,yBAAA;AAjCN;;AAsCA;EACE;IACE,kEAAA;IACA,8BAAA;IACA,+BAAA;IACA,mBAAA;EAnCF;EAsCA;IACE,YAAA;IACA,qBAAA;EApCF;EAsCE;IACE,kBAAA;EApCJ;EAuCE;IACE,kBAAA;IACA,eAAA;EArCJ;EAyCA;IACE,WAAA;IACA,YAAA;EAvCF;EA0CA;IACE,sBAAA;IACA,uBAAA;IACA,YAAA;IACA,uBAAA;EAxCF;EA2CA;IACE,0BAAA;IACA,YAAA;IACA,mBAAA;EAzCF;EA4CA;IACE,eAAA;EA1CF;EA6CA;IACE,8BAAA;IACA,oBAAA;IACA,YAAA;EA3CF;EA6CE;;IAEE,WAAA;IACA,gBAAA;IACA,kBAAA;IACA,uBAAA;EA3CJ;AACF","sourcesContent":[".guide-slot-dialog {\n  width: 100%;\n  max-width: min(640px, 100%);\n  box-sizing: border-box;\n  padding: 1.35rem 1.4rem 1.5rem;\n  max-height: min(90vh, 860px);\n  max-height: min(90dvh, 860px);\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n  margin-bottom: 1.1rem;\n\n  .eyebrow {\n    margin: 0;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    color: #5ea1d8;\n  }\n\n  h2 {\n    margin: 0.25rem 0 0.35rem;\n    font-size: 1.35rem;\n    color: #0f172a;\n  }\n\n  .subtitle {\n    margin: 0;\n    color: #64748b;\n    font-size: 0.9rem;\n    line-height: 1.45;\n    max-width: 480px;\n  }\n}\n\n.close-btn {\n  border: none;\n  background: #f1f5f9;\n  border-radius: 999px;\n  width: 2rem;\n  height: 2rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.balance-banner {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.85rem 1rem;\n  margin-bottom: 1rem;\n  border-radius: 12px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n\n  .label {\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #64748b;\n  }\n\n  .value {\n    font-weight: 700;\n    color: #0f172a;\n  }\n}\n\n.pack-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.75rem;\n  margin-bottom: 1.25rem;\n}\n\n.pack-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.25rem;\n  padding: 0.9rem;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n\n  &.selected {\n    border-color: #5ea1d8;\n    box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.35);\n  }\n\n  &.featured {\n    border-color: rgba(232, 62, 140, 0.35);\n  }\n\n  .badge {\n    position: absolute;\n    top: -0.5rem;\n    right: 0.65rem;\n    background: #e83e8c;\n    color: #fff;\n    font-size: 0.65rem;\n    padding: 0.15rem 0.45rem;\n    border-radius: 999px;\n  }\n\n  .pack-name {\n    font-weight: 700;\n    color: #0f172a;\n  }\n\n  .pack-guides {\n    color: #5ea1d8;\n    font-weight: 600;\n  }\n\n  .pack-price {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: #0f172a;\n  }\n\n  .pack-note {\n    font-size: 0.75rem;\n    color: #64748b;\n  }\n}\n\n.dialog-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n\n  .btn-cancel,\n  .btn-purchase {\n    border-radius: 999px;\n    padding: 0.65rem 1.1rem;\n    font-weight: 600;\n    cursor: pointer;\n  }\n\n  .btn-cancel {\n    border: 1px solid #e2e8f0;\n    background: #fff;\n    color: #334155;\n  }\n\n  .btn-purchase {\n    border: none;\n    background: #e83e8c;\n    color: #fff;\n  }\n}\n\n/* Dark mode — guide slot top-up modal */\n:host-context(body.theme-dark) {\n  .guide-slot-dialog {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n  }\n\n  .dialog-header {\n    .eyebrow {\n      color: #93c5fd !important;\n    }\n\n    h2 {\n      color: #f8fafc !important;\n    }\n\n    .subtitle {\n      color: #94a3b8 !important;\n    }\n  }\n\n  .close-btn {\n    background: #1f2937 !important;\n    color: #e2e8f0 !important;\n\n    mat-icon,\n    .mat-icon {\n      color: #e2e8f0 !important;\n    }\n  }\n\n  .balance-banner {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    .label {\n      color: #94a3b8 !important;\n    }\n\n    .value {\n      color: #f8fafc !important;\n    }\n  }\n\n  .pack-card {\n    background: #1f2937 !important;\n    border-color: rgba(148, 163, 184, 0.28) !important;\n\n    &.selected {\n      border-color: #5ea1d8 !important;\n      box-shadow: 0 0 0 1px rgba(94, 161, 216, 0.35) !important;\n    }\n\n    &.featured {\n      border-color: rgba(232, 62, 140, 0.45) !important;\n    }\n\n    .pack-name,\n    .pack-price {\n      color: #f8fafc !important;\n    }\n\n    .pack-guides {\n      color: #93c5fd !important;\n    }\n\n    .pack-note {\n      color: #94a3b8 !important;\n    }\n  }\n\n  .dialog-actions {\n    .btn-cancel {\n      background: #1f2937 !important;\n      border-color: rgba(148, 163, 184, 0.45) !important;\n      color: #e2e8f0 !important;\n    }\n\n    .btn-purchase {\n      color: #ffffff !important;\n    }\n  }\n}\n\n@media (max-width: 640px) {\n  .guide-slot-dialog {\n    padding: 1rem 0.9rem calc(1rem + env(safe-area-inset-bottom, 0px));\n    max-height: calc(100vh - 16px);\n    max-height: calc(100dvh - 16px);\n    border-radius: 16px;\n  }\n\n  .dialog-header {\n    gap: 0.65rem;\n    margin-bottom: 0.9rem;\n\n    h2 {\n      font-size: 1.15rem;\n    }\n\n    .subtitle {\n      font-size: 0.82rem;\n      max-width: none;\n    }\n  }\n\n  .close-btn {\n    width: 32px;\n    height: 32px;\n  }\n\n  .balance-banner {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.35rem;\n    padding: 0.7rem 0.85rem;\n  }\n\n  .pack-grid {\n    grid-template-columns: 1fr;\n    gap: 0.65rem;\n    margin-bottom: 1rem;\n  }\n\n  .pack-card {\n    padding: 0.9rem;\n  }\n\n  .dialog-actions {\n    flex-direction: column-reverse;\n    align-items: stretch;\n    gap: 0.55rem;\n\n    .btn-cancel,\n    .btn-purchase {\n      width: 100%;\n      min-height: 44px;\n      border-radius: 8px;\n      justify-content: center;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
